// libs
import React, { memo } from 'react';
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

// components
import Tag from 'shared/components/Product/components/Tag';

export const Container = styled.div`
  margin-bottom: ${({ theme }) => theme.spacing.spacing20};
  height: 18px;
  display: flex;
  flex-wrap: wrap;
  overflow: hidden;
  margin-left: -${({ theme }) => theme.spacing.spacing20};

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    height: 20px;
  }
`;

interface IMultiTagsProps {
  tagData?: Listing.IProductTag[];
  dataTest?: string;
  className?: string;
  saleExp?: boolean;
}

function MultiTags({ dataTest, tagData, className = '', saleExp }: IMultiTagsProps) {
  if (tagData === undefined || Array.isArray(tagData) === false) {
    return null;
  }

  return (
    <Container data-test={dataTest}>
      {tagData.map((item: Listing.IProductTag, idx: number) => {
        return <Tag data-test="product-tag" key={idx} item={item} className={className} saleExp={saleExp}></Tag>;
      })}
    </Container>
  );
}

export default memo(MultiTags);
